import { isValidValue } from "utils/validators";

const glPrefixes = ["Xero", "MYOB", "SageOne", "QBO", "SaasuV2"];

export const findIntegrationInUse = (categories) => glPrefixes.find((prefix) => (
  categories.some((category) => category.name.startsWith(prefix))
));

export const getIntegrationText = (integrationStatus, integrationText, noIntegrationText) => {
  if (isValidValue(integrationStatus)) {
    return `${integrationText} ${integrationStatus}`;
  }
  return noIntegrationText;
};



// WEBPACK FOOTER //
// ./src/js/utils/check-integration.js